module.exports = __webpack_public_path__ + "img/8t.b8964b21.jpg";